<form
  (ngSubmit)="onSubmit()"
  [formGroup]="formGroup">
  <love-it-modal-header
    (close)="closeModal()"
  [title]="editText"></love-it-modal-header>
  @if (entity) {
    <div class="modal-body text-end status-header">
      <div>Erstellt am {{ entity?.createdDate | date: "dd.MM.yyy HH:mm" : undefined : "de-AT" }}</div>
      <div>Zuletzt geändert am {{ lastUpdatedDate() | date: "dd.MM.yyy HH:mm" : undefined : "de-AT" }}</div>
    </div>
  }
  <div class="modal-body">
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-sm-6">
            <label
              class="required-label"
              for="officeId"
              >Bericht für</label
              >
              <ng-select
                [formControl]="formGroup.get('officeId') | formControl"
                [items]="formGroupService.offices"
                bindLabel="name"
                bindValue="id"
                [clearable]="false"
                [searchable]="false"
                id="officeId"
              [ngClass]="{
                'is-invalid': submitted && formGroup.get('officeId')?.errors,
              }"></ng-select>
              @if (submitted && formGroup.get("officeId")?.errors) {
                <div class="invalid-feedback">
                  @if (formGroup.get("officeId")?.errors["required"]) {
                    <div>Bericht für ist ein Pflichtfeld.</div>
                  }
                </div>
              }
            </div>
            @if (formGroup.get("officeId").value) {
              @if (isHousingReport) {
                <div class="col-sm-6">
                  <label
                    class="required-label"
                    for="housingId"
                    >Wohnung</label
                    >
                    <ng-select
                      [formControl]="formGroup.get('housingId') | formControl"
                      [items]="housing"
                      bindLabel="name"
                      bindValue="id"
                      [clearable]="false"
                      [searchable]="false"
                      id="housingId"
                  [ngClass]="{
                    'is-invalid': submitted && formGroup.get('housingId')?.errors,
                  }"></ng-select>
                    @if (submitted && formGroup.get("housingId")?.errors) {
                      <div class="invalid-feedback">
                        @if (formGroup.get("housingId")?.errors["required"]) {
                          <div>Wohnung ist ein Pflichtfeld.</div>
                        }
                      </div>
                    }
                  </div>
                } @else {
                  <div class="col-sm-6">
                    <label class="required-label" for="subject">Betreff</label>
                    <ng-select
                      [formControl]="formGroup.get('subject') | formControl"
                      [items]="subjects"
                      bindLabel="display"
                      bindValue="value"
                      [clearable]="false"
                      [searchable]="false"
                    id="subject"></ng-select>
                  </div>
                }
              } @else {
                <div class="col-sm-6"></div>
              }
              <div class="col-sm-6">
                <label
                  class="required-label"
                  for="mainEmployeeId"
                  >Verfasser:in</label
                  >
                  <ng-select
                    [formControl]="formGroup.get('mainEmployeeId') | formControl"
                    [items]="employees"
                    bindLabel="name"
                    bindValue="id"
                    [clearable]="false"
                    id="mainEmployeeId"
                    [searchable]="true"
              [ngClass]="{
                'is-invalid': submitted && formGroup.get('mainEmployeeId')?.errors,
              }"></ng-select>
                  @if (submitted && formGroup.get("mainEmployeeId")?.errors) {
                    <div class="invalid-feedback">
                      @if (formGroup.get("mainEmployeeId")?.errors["required"]) {
                        <div>Verfasser:in ist ein Pflichtfeld.</div>
                      }
                    </div>
                  }
                </div>
                <div class="col-sm-6">
                  <label for="otherEmployees">Weitere anwesende Betreuer:innen</label>
                  <ng-select
                    [formControl]="formGroup.get('otherEmployees') | formControl"
                    [items]="employees | filterEmployeesByEmployee: formGroup.get('mainEmployeeId')?.value"
                    bindLabel="name"
                    bindValue="id"
                    [clearable]="false"
                    id="otherEmployees"
                    [searchable]="true"
                    [multiple]="true"
              [ngClass]="{
                'is-invalid': submitted && formGroup.get('otherEmployees')?.errors,
              }"></ng-select>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Berichtseinträge</h4>
            </div>
            <div class="card-body">
              @for (reportEntry of (formGroup.get("reportEntries") | formArray)?.controls; let i = $index; track i) {
                <div
                  class="row mb-2"
                  [ngClass]="{ 'border-top': i > 0, 'pt-2': i > 0 }">
                  <div class="col-sm-6">
                    <label
                      [for]="'desciption' + i"
                      class="required-label">
                      Beschreibung </label
                      ><br />
                      <quill-editor
                        [id]="'desciption' + i"
                        class="w-100"
                        [formControl]="reportEntry.get('details') | formControl"
                [ngClass]="{
                  'is-invalid': submitted && reportEntry.get('details')?.errors,
                }"></quill-editor>
                      @if (submitted && reportEntry.get("details")?.errors) {
                        <div class="invalid-feedback">
                          @if (reportEntry.get("details")?.errors["required"]) {
                            <div>Beschreibung ist ein Pflichtfeld.</div>
                          }
                        </div>
                      }
                    </div>
                    <div class="col-sm-4">
                      <div class="mb-2">
                        <label [for]="'affectedClients' + i">Relevant für Klient:innen</label>
                        <ng-select
                          [formControl]="reportEntry.get('affectedClients') | formControl"
                          [items]="clients"
                          bindLabel="name"
                          bindValue="id"
                          [clearable]="false"
                          [id]="'affectedClients' + i"
                          [searchable]="true"
                        [multiple]="true"></ng-select>
                      </div>
                      <div>
                        <label class="required-label" [for]="'reportEntryCategory' + i">Kategorie</label>
                        <ng-select
                          [formControl]="reportEntry.get('category') | formControl"
                          [items]="reportEntryCategoryOptions"
                          bindLabel="display"
                          bindValue="value"
                          [clearable]="false"
                          [id]="'reportEntryCategory' + i"
                          [searchable]="false"
                          [ngClass]="{ 'is-invalid': submitted && reportEntry.get('category')?.errors }">
                        </ng-select>
                        @if (submitted && reportEntry.get("category")?.errors) {
                          <div class="invalid-feedback">
                            @if (reportEntry.get("category")?.errors["required"]) {
                              <div>Kategorie ist ein Pflichtfeld.</div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                    <div class="col-sm-1">
                      <div>
                        <label [for]="'isIncident' + i">Vorfall</label>
                        <div class="love-it-checkbox-centered">
                          <input
                            type="checkbox"
                            class="form-check-input"
                            [id]="'isIncident' + i"
                            [formControl]="reportEntry.get('isIncident') | formControl" />
                        </div>
                      </div>
                      @if (reportEntry.get("isIncident")?.value){
                        <div>
                          <label [for]="'isBlueLightIncident' + i">Blaulicht-Vorfall</label>
                          <div class="love-it-checkbox-centered">
                            <input
                              type="checkbox"
                              class="form-check-input"
                              [id]="'isBlueLightIncident' + i"
                              [formControl]="reportEntry.get('isBlueLightIncident') | formControl" />
                          </div>
                        </div>
                      }
                    </div>
                    <div class="col-sm-1 mt-2">
                      @if (!isKJHReport && i > 0) {
                        <button
                          rippleEffect
                          type="button"
                          class="btn-mobile-group btn-outline-danger mt-1"
                          (click)="formGroupService.removeReportEntry(i)"
                          >
                          <i data-feather="trash"></i>
                        </button>
                      }
                    </div>
                  </div>
                }
                @if (!isKJHReport){
                  <div class="row">
                    <div class="datatable-add-button">
                      <button
                        type="button"
                        rippleEffect
                        (click)="formGroupService.addReportEntry()">
                        <i
                          data-feather="plus"
                          class="datatable-add-button-icon"></i
                          ><span class="datatable-add-button-text">Berichteintrag hinzufügen</span>
                        </button>
                      </div>
                    </div>
                }
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <love-it-modal-buttons
                (onSubmit)="onSubmit($event)"
                [dirty]="formGroup.dirty"
              [showSpeichernButton]="CaslAction.Update | permission: EntityTyp.Report"></love-it-modal-buttons>
            </div>
          </form>
